var App = App || {};

App.SideScrollImageBand = (function ($) {
    "use strict";

    function init() {

        const ssImageBands = $(".component.component-ss-image-band");
        if (ssImageBands.length) {
            ssImageBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(ssImageBand) {
        const carousel = ssImageBand.find(".image-slider.splide");

        const splideCarousel = new Splide(carousel[0], {
            pagination: false,
            type: 'loop',
            fixedWidth: "350px",
            gap: "30px",
            drag: true,
            snap: false,
            breakpoints: {
                991: {
                    fixedWidth: "216px",
                    gap: "15px",
                },
            }
        });

        splideCarousel.on('ready active', function () {
        });

        splideCarousel.mount();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SideScrollImageBand.init();
});